import { ArrowRightOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Display } from '@/components/Display/Display';
import s from './style.module.scss';
import { cloneDeep } from 'lodash';
import SendFile from './components/SendFile';

import React, { useEffect, useRef, useState } from 'react';
import UseSendFile from '@/pages/hooks/useSendFile';
import { inject, observer } from 'mobx-react';
const SenderFiles = (props) => {
    const { chatStore } = props.store;
    const { setAgentFile, agentFile: fileList } = chatStore;
    const listRef = useRef();
    const { needParse = false } = props;
    const [isAtLeft, setIsAtLeft] = useState(true);
    const [isAtRight, setIsAtRight] = useState(false);
    const [showArrow, setShowArrow] = useState({
        left: false,
        right: false
    });
    const { command, canClickCommand, handleCommand } = UseSendFile();

    const close = (index) => {
        let temData = cloneDeep(fileList);

        temData.splice(index, 1);
        setAgentFile(temData);
    };
    const getScrollBoxEdge = () => {
        let scrollBox = listRef.current;
        const { scrollLeft, scrollWidth, clientWidth } = scrollBox;
        const isAtLeft = scrollLeft === 0;
        const isAtRight = scrollLeft >= scrollWidth - clientWidth - 1;
        return {
            isAtLeft,
            isAtRight
        };
    };
    useEffect(() => {
        const dom = listRef.current;
        const isOverflowing = dom.offsetWidth < dom.scrollWidth;
        let { isAtLeft, isAtRight } = getScrollBoxEdge();
        setShowArrow({
            left: isOverflowing && !isAtLeft,
            right: isOverflowing && !isAtRight
        });
    }, [isAtLeft, isAtRight, fileList]);
    useEffect(() => {
        const dom = listRef.current;
        const isOverflowing = dom.offsetWidth < dom.scrollWidth;
        if (isOverflowing) {
            dom.scrollTo({
                left: dom.scrollWidth,
                behavior: 'smooth'
            });
        }
    }, [fileList.length]);
    const onScroll = () => {
        let { isAtLeft, isAtRight } = getScrollBoxEdge();
        setIsAtLeft(isAtLeft);
        setIsAtRight(isAtRight);
    };
    const onClickArrow = (direction) => {
        let scrollBox = listRef.current;
        const { scrollLeft } = scrollBox;
        let left = scrollLeft;
        if (direction === 'left') {
            left = scrollLeft - 200;
        } else {
            left = scrollLeft + 200;
        }
        listRef.current.scrollTo({
            left: left,
            behavior: 'smooth'
        });
    };

    // useEffect(() => {
    //     handleCommand(fileList);
    // }, [fileList]);
    const changeFile = (index, file) => {
        // 关键：传递更新器函数给setAgentFile，入参是Mobx维护的最新fileList状态
        setAgentFile((latestFileList) => {
            // 基于最新状态深克隆，避免修改原始Mobx状态
            const temData = cloneDeep(latestFileList);
            // 对最新的克隆数组执行修改
            temData[index] = file;
            // 返回新的数组作为最新状态
            return temData;
        });
    };

    return (
        <>
            <div className={s['files-wrap']} data-from={'sender'}>
                <Display show={showArrow.left}>
                    <div className={s['arrow-left']} onClick={() => onClickArrow('left')}>
                        <LeftOutlined />
                    </div>
                </Display>
                <div
                    ref={listRef}
                    className={s['file-list-wrap']}
                    data-from={'sender'}
                    data-left={!isAtLeft}
                    data-right={!isAtRight}
                    onScroll={onScroll}
                >
                    {fileList.map((ele, index) => {
                        return (
                            <React.Fragment key={ele?.uid || index}>
                                <SendFile
                                    needParse={needParse}
                                    from={'sender'}
                                    changeFile={changeFile}
                                    close={close}
                                    index={index}
                                    file={ele}
                                ></SendFile>
                            </React.Fragment>
                        );
                    })}
                </div>
                <Display show={showArrow.right}>
                    <div className={s['arrow-right']} onClick={() => onClickArrow('right')}>
                        <RightOutlined />
                    </div>
                </Display>
            </div>
            <Display show={command.length > 0}>
                <div className={s['tip-word-wrap']}>
                    {command.map((ele, index) => {
                        return (
                            <div data-disable={!canClickCommand} key={index} className={s['tip-word']}>
                                <span>{ele}</span>
                                <span>
                                    <ArrowRightOutlined />
                                </span>
                            </div>
                        );
                    })}
                </div>
            </Display>
        </>
    );
};

export default inject('store')(observer(SenderFiles));
